<script setup>
import { onMounted } from 'vue'

const other = await queryContent('/other').findOne()
const { init: initYandexMetrika } = useYandexMetrika()

onMounted(() => {
  initYandexMetrika()
})

useHead({
  title: other.pageTitle,
  meta: [
    {
      name: 'description',
      content: other.pageDescription
    }
  ],
  htmlAttrs: {
    lang: 'ru'
  },
  link: [
    { rel: 'icon', type: 'image/ico', href: '/favicon.ico' }
  ]
})
</script>

<template>
  <MenuMain />
  <BannerMain />
  <EventMain />
  <AboutEvent />
  <WhoFits />
  <TopSpeakers />
  <YouGet />
  <SubscribeCommunity />
  <PartnersSection />
  <ContactsOrganizers />
  <ReservePlace />
  <FooterMain />
</template>
